import { ReportStateModel } from 'modules/dashboard/types';
import { HorizontalStepper } from 'components/molecules/horizontal-stepper/HorizontalStepper';
import { useNavigate } from 'react-router-dom';
import { GoToStepProps, StepNumber } from 'types/stepper/stepper.type';
import { reportStepToRoute } from 'modules/reports/utils/report-stepper/report-route-mappings';
import { getReportStepConfig } from 'modules/reports/utils/report-stepper/report-step-configuration';
import useStepLogic from 'modules/reports/utils/report-stepper/report-step-validations';
import { StepperCategoryState } from 'types/stepper/proposal-stepper-type';

interface ReportStepperProps {
  currentStep: StepNumber;
}

export type StepConfig = {
  step: StepNumber;
  title: string;
  state: StepperCategoryState;
  customIsDisabled?: boolean;
};

const defaultFormState: ReportStateModel = {
  step1: 'Default',
  step2: 'Default',
  step3: 'Default'
};

export const ReportStepper = ({ currentStep }: ReportStepperProps) => {
  const navigate = useNavigate();
  const stepConfig = getReportStepConfig(defaultFormState);
  const { isStepDisabled } = useStepLogic(currentStep);

  const goToStep = ({ step }: GoToStepProps) => navigate(reportStepToRoute(step));

  return (
    <HorizontalStepper
      stepConfig={stepConfig}
      currentStep={currentStep}
      goToStep={goToStep}
      isStepDisabled={isStepDisabled}
    />
  );
};
